import React from "react";

export interface LoadingIndicatorContextValue {
  onStartLoading: () => void;
  onStopLoading: () => void;
}

export const LoadingIndicatorContext =
  React.createContext<LoadingIndicatorContextValue>(null!);

export const useLoadingIndicator = (defaultState: boolean) => {
  const isLoading = React.useRef(defaultState);
  const { onStartLoading, onStopLoading } = React.useContext(
    LoadingIndicatorContext
  );

  const startLoading = React.useCallback(() => {
    if (!isLoading.current) {
      isLoading.current = true;
      onStartLoading();
    }
  }, [onStartLoading]);

  const stopLoading = React.useCallback(() => {
    if (isLoading.current) {
      isLoading.current = false;
      onStopLoading();
    }
  }, [onStopLoading]);

  React.useEffect(() => {
    if (defaultState) {
      onStartLoading();
    }
    return () => {
      stopLoading();
    };
  }, [defaultState, onStartLoading, stopLoading]);

  return { startLoading, stopLoading };
};
